import { Divider } from '@shared/ui';

import cls from './SettingsTabContent.module.css';
import { ApiTokenSettings } from '../ApiTokenSettings';
import { DeleteProfileSettings } from '../DeleteProfileSettings';
import { HintsSettings } from '../HintsSettings';
import { NotificationSettings } from '../NotificationSettings';
import { PasswordSettings } from '../PasswordSettings';

import type { Profile } from '@entities/profile';

type SettingsTabContentProps = {
    profile: Profile;
    onPaySubscriptionClick?: ({ removeProlong }: { removeProlong: boolean }) => void;
};

export const SettingsTabContent = ({
    profile,
    onPaySubscriptionClick,
}: SettingsTabContentProps) => (
    <div className={cls.settingsContent}>
        <PasswordSettings />
        <Divider classes={cls.settingsDivider} />
        <HintsSettings profile={profile} />
        <Divider classes={cls.settingsDivider} />
        <ApiTokenSettings profile={profile} onPaySubscriptionClick={onPaySubscriptionClick} />
        <NotificationSettings profile={profile} />
        <Divider classes={cls.settingsDivider} />
        <DeleteProfileSettings />
    </div>
);
